import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, IconButton, Icon } from 'rsuite'
import LawDocumentformForm from './LawDocumentformForm'
import LawDocumentformView from './LawDocumentformView'
import { useForm, Controller } from 'react-hook-form'
import {
  getDownload,
  deleteLawDocumentForm,
  getLawDocumentForm,
  saveLawDocumentForm,
  updateAttachments,
} from '../../redux/actions/lawDocumentform'
import { startLoading, doneLoading } from '../../utils/loading'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

export default function LawDocumentformWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, loadMenu } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(projectId, request)

      console.log('response', response)

      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response
        setIsEditErr(false)
        setFormSchema(_schema)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveLawDocumentForm(request)

      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response.model.forms.attachment.attachFiles
        setFormSchema(_schema)
        setIsUploadErr(false)
        // if (loadMenu) {
        //   await dispatch(getSchemaSidebar(projectId))
        // }
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.', schema)
      const status = await deleteLawDocumentForm(schema.id)

      if (status === 200) {
        console.log('call get.')
        const response = await getLawDocumentForm(projectId)

        setFormSchema(response.model.forms.attachment)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownload(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownload(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('Id', null)
    formData.append('Category', data.fileCategory || 0)
    formData.append('Note', data.note || '')

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file.label = newName

    console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.attachFiles.value]
    handleDelete(datas[index])
  }

  const onChangSeqNo = async (data, seqNo) => {
    console.log('onChangSeqNo data', data)

    startLoading()
    setIsLoading(true)
    // setIsUploadErr()
    try {
      console.log('onChangSeqNo')
      const response = await changeAttachmentSeqNo(projectId, data.id, seqNo)
      console.log('onChangSeqNo response', response)

      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response
        setFormSchema(_schema)
        // setIsUploadErr(false)
      } else {
        // setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      // setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  // console.log('formSchema ', formSchema.attachFiles)

  return (
    <Panel
      shaded
      header={formSchema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <LawDocumentformForm
          schema={formSchema.attachFiles}
          schemafileCategory={formSchema.fileCategory}
          schemaNote={formSchema.note}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onUpload)}
          onDelete={onDelete}
          onUpdate={onUpdate}
          onDownload={onDownload}
          onPreview={onPreview}
          onChangSeqNo={onChangSeqNo}
          isChangSeqNo={true}
          isEditErr={isEditErr}
          isUploadErr={isUploadErr}
          isDeleteError={isDeleteError}
          loading={isLoading}
          buttonText={formSchema.buttonText}
        />
      ) : (
        <LawDocumentformView
          schema={formSchema.attachFiles}
          schemafileCategory={formSchema.fileCategory}
          schemaNote={formSchema.note}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      )}

      {/* {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              <ViewButton
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  setIsEditErr(false)
                  setIsDeleteError(false)
                  setIsUploadErr(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsEditErr(false)
                setIsDeleteError(false)
                setIsUploadErr(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}
        </>
      )} */}
    </Panel>
  )
}
